var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14691 7.30476L10.8611 12.0189C11.0182 12.1707 11.2287 12.2547 11.4472 12.2528C11.6657 12.2509 11.8748 12.1633 12.0293 12.0088C12.1838 11.8543 12.2714 11.6453 12.2733 11.4268C12.2752 11.2083 12.1912 10.9978 12.0394 10.8406L7.32524 6.12643L12.0394 1.41226C12.1912 1.25509 12.2752 1.04459 12.2733 0.826092C12.2714 0.607595 12.1838 0.398585 12.0293 0.244078C11.8748 0.0895712 11.6657 0.00193018 11.4472 3.15022e-05C11.2287 -0.00186718 11.0182 0.0821281 10.8611 0.233926L6.14691 4.94809L1.43274 0.233926C1.27486 0.0858805 1.06558 0.00506442 0.849182 0.00857841C0.63278 0.0120924 0.426234 0.099661 0.273248 0.252755C0.120262 0.405849 0.0328398 0.612456 0.0294789 0.828861C0.026118 1.04527 0.107082 1.25449 0.25524 1.41226L4.96857 6.12643L0.254407 10.8406C0.174815 10.9175 0.11133 11.0094 0.0676557 11.1111C0.0239816 11.2128 0.000992978 11.3221 3.14642e-05 11.4328C-0.000930049 11.5434 0.0201545 11.6531 0.0620553 11.7556C0.103956 11.858 0.165834 11.951 0.244078 12.0293C0.322321 12.1075 0.415365 12.1694 0.517778 12.2113C0.620192 12.2532 0.729925 12.2743 0.840574 12.2733C0.951224 12.2723 1.06057 12.2494 1.16224 12.2057C1.26391 12.162 1.35587 12.0985 1.43274 12.0189L6.14691 7.30476Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.beecf65f8fbfe37591ec427b3c053453.svg";
export { ForwardRef as ReactComponent };